import { FC } from 'react';

interface SuccessIconProps {
  width?: string;
  height?: string;
}

export const SuccessIcon: FC<SuccessIconProps> = ({ width = '32', height = '32' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path
        opacity="0.66"
        d="M16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0ZM14 20L9.5 16L7.5 18.5L14.5 24.5L26 10L23 8L14 20Z"
        fill="url(#paint0_linear_5234_24560)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5234_24560"
          x1="38.8357"
          y1="-15.5375"
          x2="51.8112"
          y2="29.929"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9BCD4F" />
          <stop offset="0.929667" stopColor="#9BCD4F" stopOpacity="0.12" />
        </linearGradient>
      </defs>
    </svg>
  );
};
